<template>
  <card-seplag titulo="Escala Anual">
    <cadastro-rapido
      tituloTela="Escala Anual"
      tamanhoTela="900"
      v-model="exibirTela"
      :modoEdicao="modoEdicao"
      :onfecharModal="fecharModalNovaEscala"
      :onAdicionar="adicionarRegistro"
      :onAlterar="alterarRegistro"
      v-if="registro"
    >
      <Rotulo nome="Exercício" cols="12 4">
        <Dropdown
          v-model="registro.exercicio"
          :options="exercicios"
          optionLabel="ano"
          placeholder="Selecione..."
          :filter="true"
          v-required
        />
      </Rotulo>
      <Rotulo nome="Descrição">
        <InputText type="text" v-model="registro.descEscala" v-required />
      </Rotulo>
      <Rotulo nome="Tipo de afastamento" cols="12 4">
        <Dropdown
          v-model="registro.tipoEscala"
          :options="tiposAfastamento"
          optionValue="codigo"
          optionLabel="descTipoAfastamento"
          placeholder="Selecione..."
          v-required
          :disabled="modoEdicao == 'alterar'"
        />
      </Rotulo>
      <Rotulo nome="Data Inícial da Escala" cols="12 4">
        <InputMask
          mask="99/99/9999"
          placeholder="dd/mm/aaaa"
          v-model="registro.dataInicio"
          v-required
        />
      </Rotulo>
      <Rotulo nome="Data Final da Escala" cols="12 4">
        <InputMask
          mask="99/99/9999"
          placeholder="dd/mm/aaaa"
          v-model="registro.dataFim"
          v-required
        />
      </Rotulo>
      <div class="p-col-12">
        <fieldset
          style="
            border: 1.5px solid #1e4ea8;
            border-radius: 12px;
            padding: 1rem;
            background: #f9fbfd;
          "
        >
          <legend style="font-weight: bold; color: #1e4ea8; padding: 0 5px">
            Dados de Publicação do IOMAT
          </legend>

          <div class="p-grid p-fluid">
            <Rotulo cols="12 3" nome="Número D.O">
              <InputText
                type="text"
                v-model="registro.numrDo"
                :disabled="modoEdicao != 'alterar'"
              />
            </Rotulo>

            <Rotulo cols="12 3" nome="Página">
              <InputText
                type="text"
                v-model="registro.numrPaginaDo"
                :disabled="modoEdicao != 'alterar'"
              />
            </Rotulo>

            <Rotulo cols="12 3" nome="Data Publicação">
              <InputMask
                mask="99/99/9999"
                placeholder="dd/mm/aaaa"
                v-model="registro.dataPublicacaoDo"
                :disabled="modoEdicao != 'alterar'"
              />
            </Rotulo>

            <Rotulo cols="12 3" nome="Número do Processo">
              <InputText
                type="text"
                v-model="registro.protocoloSigadoc"
                :disabled="modoEdicao != 'alterar'"
              />
            </Rotulo>
          </div>
          <!-- Observação -->
          <div class="p-col-12" style="margin-top: 0.75rem">
            <div
              style="
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 0.9rem;
                color: #555;
              "
            >
              <i
                class="pi pi-info-circle"
                style="color: #1e4ea8; font-size: 1rem"
              ></i>
              <span
                >Esses campos deverão ser preenchidos após a publicação no
                Diário Oficial.</span
              >
            </div>
          </div>
        </fieldset>
      </div>

      <div class="p-col-12" v-if="modoEdicao != 'alterar'">
        <label><strong>Selecione os Orgãos: </strong></label>
      </div>
      <div class="p-col-12 orgaosEscala" v-if="modoEdicao != 'alterar'">
        <DataTable :value="orgaos">
          <Column headerStyle="width:7%;">
            <template #header>
              <Checkbox
                id="checkAll"
                :inputId="'checkAll'"
                name="checkAll"
                :value="true"
                v-model="checkAllSelect"
                @change="selecionarTudo"
              />
            </template>
            <template #body="slotProps">
              <Checkbox
                :id="slotProps.data.idenOrgao"
                :inputId="slotProps.data.idenOrgao"
                name="orgaosEscala"
                :value="slotProps.data"
                v-model="registro.listaOrgaos"
              />
            </template>
          </Column>
          <Column class="align-right" field="codSeap" header="Seap"></Column>
          <Column field="descOrgao" header="Órgão"></Column>

          <template #empty>
            <p style="font-weight: 600; text-align: center">
              Todos os órgãos já possuem escala
            </p>
          </template>
        </DataTable>
      </div>
    </cadastro-rapido>

    <div class="p-grid p-col-12">
      <div class="p-col-12 p-md-4">
        <Dropdown
          v-model="orgaoSelecionado"
          :options="orgaoBusca"
          optionLabel="labelDropDaw"
          placeholder="Selecione..."
          :filter="true"
        />
      </div>
      <div class="p-col-12 p-md-2">
        <div class="alinahmentoBuscaFiltroOrgaoEscala p-grid">
          <Dropdown
            class="alinhamentoCampoStatusFiltroOrgaoEscala"
            v-model="filtroBusca"
            :options="opcaoBuscaFiltro"
            optionLabel="name"
            optionValue="code"
            placeholder="Selecione..."
          />
          <Button icon="pi pi-search" @click="buscarFiltro()"></Button>
        </div>
      </div>
    </div>
    <div class="p-col-12">
      <DataTable
        :value="escalas"
        class="p-datatable-responsive"
        dataKey="idenEscala"
        :paginator="true"
        :rows="15"
      >
        <template #header>
          <div
            class="p-grid alinahmentoCabecalhoTabelaOrgaoEscala"
            v-if="possuiPermissao"
          >
            <div class="p-col-4">
              <Button
                label="Adicionar"
                icon="pi pi-plus"
                @click="incluirRegistro"
              ></Button>
            </div>
          </div>
        </template>

        <Column
          field="exercicio"
          header="Exercício"
          headerStyle="width: 9em"
          bodyStyle="text-align: center"
        >
          <template #body="slotProps">
            {{ slotProps.data.exercicio.ano }}
          </template>
        </Column>
        <Column
          headerStyle="width: 13em"
          field="tipoEscala"
          header="Tipo Afastamento"
          bodyStyle="text-align: center"
        ></Column>
        <Column
          field="descEscala"
          header="Descrição"
          headerStyle="width: 25em"
        ></Column>
        <Column field="dataInicio" header="Período" bodyStyle="width:10%">
          <template #body="slotProps">
            {{ slotProps.data.dataInicio }} à {{ slotProps.data.dataFim }}
          </template>
        </Column>

        <Column
          field="protocoloSigadoc"
          header="Protocolo"
          bodyStyle="width:10%;text-align: center"
        ></Column>
        <Column
          field="numrDo"
          header="D.O"
          bodyStyle="width:10%;text-align: center"
        ></Column>

        <Column
          headerStyle="width: 9em"
          bodyStyle="text-align: center"
          field="status"
          header="Status"
          class="p-col-1"
        >
          <template #body="slotProps">
            <span
              v-if="slotProps.data.situacao == 'ABERTO'"
              class="customer-badge-aguardando"
              >Aberto</span
            >
            <span
              v-else-if="slotProps.data.situacao == 'FECHADO'"
              class="customer-badge-conflito"
              >Fechado</span
            >
            <span v-else class="customer-badge-conflito">Encerrado</span>
          </template>
        </Column>

        <Column
          field=""
          header="Ação"
          bodyStyle="width:10%;text-align: center;"
        >
          <template #body="slotProps">
            <Button
              type="button"
              icon="pi pi-eye"
              @click="visualizarRegistro(slotProps.data)"
              class="p-button-warning"
              style="margin-right: 0.2em"
            ></Button>
            <Button
              type="button"
              icon="pi pi-pencil"
              @click="editarRegistro(slotProps.data)"
              class="p-button-success"
              style="margin-right: 0.2em"
            ></Button>
            <Button
              type="button"
              icon="pi pi-trash"
              @click="excluirRegistro(slotProps.data)"
              class="p-button-danger"
              :disabled="!possuiPermissao"
            ></Button>
          </template>
        </Column>
      </DataTable>
    </div>
  </card-seplag>
</template>
<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
// import TableSeplag from '@/template/TableSeplag.vue'
// import FormSeplag from '@/template/FormSeplag.vue'
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import { baseApiUrl } from "@/config/global";
// import moment from 'moment'

const getDefaultState = () => {
  return {
    exercicio: null,
    descEscala: null,
    dataFim: "",
    dataInicio: "",
    tipoEscala: "FERIAS",
    listaOrgaos: [],
  };
};

export default {
  name: "cadEscala",
  components: { CardSeplag, Rotulo, CadastroRapido },
  data() {
    return {
      escalas: [],
      orgaoBusca: [],
      orgaos: [],
      exercicios: [],
      orgaoSelecionado: null,
      orgaoPrincipal: null,
      filtroBusca: "aberto",
      registro: getDefaultState(),
      modoEdicao: "adicionar",
      opcaoBuscaFiltro: [
        { name: "Aberto", code: "aberto" },
        { name: "Capturada", code: "capturada" },
        { name: "Transmitida", code: "transmitida" },
        { name: "Encerrado", code: "encerrado" },
      ],
      tiposAfastamento: [
        { codigo: "FERIAS", descTipoAfastamento: "Férias" },
        { codigo: "LICENCA_PREMIO", descTipoAfastamento: "Licença Prêmio" },
      ],
      exibirTela: false,
      checkAllSelect: false,
      possuiPermissao: null,
      bloquearPreencher: false,
    };
  },
  methods: {
    limparDados() {
      this.modoEdicao = "adicionar";
      this.bloquearPreencher = false;
      this.registro = getDefaultState();
    },
    async carregarDados() {
      this.orgaoPrincipal =
        this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor[0].idenOrgao;
      await this.$http
        .get(`${baseApiUrl}/escalaafastamentos/orgaosperfil`)
        .then((res) => {          
          
          this.orgaoBusca = res.data.map(element => {
            return {
                ...element,
                labelDropDaw: element.codgSeap + " - " + element.descUnidade,
            }
          });

          if (this.orgaoBusca.length > 0) {
            for (let i = 0; i < this.orgaoBusca.length; i++) {
              if (this.orgaoBusca[i].idenOrgao == this.orgaoPrincipal) {
                this.orgaoSelecionado = this.orgaoBusca[i];
              }
            }
          }          
        });
      this.filtroBusca = "aberto";

      this.$http.get(`${baseApiUrl}/exercicios/ativos`).then((res) => {
        this.exercicios = res.data;
      });

      this.$http
        .get(`${baseApiUrl}/escalaafastamentos/${this.orgaoPrincipal}/aberto`)
        .then((res) => {
          this.escalas = res.data;
        });

      this.possuiPermissao =
        this.$store.getters.getUser.contaAcesso.authorities.filter(function (
          element
        ) {
          return element.nomeRole == "PORT_ACESSO_CENTRAL_RH";
        }).length > 0;

      this.$http.get(`${baseApiUrl}/orgaos/naoextintos`).then((res) => {
        this.orgaos = res.data;
        this.registro.listaOrgaos = this.orgaos;
        this.checkAllSelect = [false];
      });
    },
    editarRegistro(dado) {
      this.registro = { ...dado };
      this.modoEdicao = "alterar";
      this.exibirTela = true;
    },
    trocarStatus() {
      if (this.registro.status == "ABERTO") {
        this.registro.status = "FECHADO";
      } else {
        this.registro.status = "ABERTO";
      }
    },
    incluirRegistro() {
      this.limparDados();
      this.registro.listaOrgaos = this.orgaos;
      this.checkAllSelect = [true];
      this.$http
        .get(`${baseApiUrl}/escalaafastamentos/resumoescala/ferias`)
        .then((res) => {
          if (res.data.dataInicio) {
            this.registro.exercicio = res.data.exercicio;
            this.registro.dataInicio = res.data.dataInicio;
            this.registro.dataFim = res.data.dataFim;
            this.registro.dataInicioAgendamento =
              res.data.dataInicioAgendamento;
            this.bloquearPreencher = true;
          }
        });
      this.modoEdicao = this.orgaos.length > 0 ? "adicionar" : "none";
      this.exibirTela = true;
    },
    adicionarRegistro() {
      this.$http
        .post(
          `${baseApiUrl}/escalaafastamentos/geral`,
          JSON.stringify(this.registro)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Registro Adicionado com Sucesso!",
            life: 3000,
          });
          this.exibirTela = false;
          this.carregarDados();
        });
    },
    alterarRegistro() {
      this.$http
        .put(
          `${baseApiUrl}/escalaafastamentos/${this.registro.idenEscalaAfastamento}`,
          JSON.stringify(this.registro)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Registro Alterado com Sucesso!",
            life: 3000,
          });
          this.exibirTela = false;
          this.carregarDados();
        });
    },
    onChangeTipoAfastamento(tipoAfastamento) {
      function success(res) {
        this.orgaos = res.data;
        this.registro.listaOrgaos = this.orgaos;
        this.checkAllSelect = [true];

        if (this.orgaos.length > 0) {
          this.modoEdicao = "adicionar";
        } else {
          this.modoEdicao = "none";
        }
      }

      if (tipoAfastamento == "LICENCA_PREMIO") {
        this.$http
          .get(`${baseApiUrl}/escalaafastamentos/semescala/licencapremio`)
          .then(success.bind(this));
      } else if (tipoAfastamento == "FERIAS") {
        this.$http
          .get(`${baseApiUrl}/escalaafastamentos/semescala/ferias`)
          .then(success.bind(this));
      }
    },
    visualizarRegistro(dado) {
      this.$store.commit("setEscalaAnualRhSelecionada", dado);
      if (dado.tipoEscala == "FERIAS") {
        this.$router.push({ name: "escalaAnualRhFerias" });
      } else if (dado.tipoEscala == "LICENCA_PREMIO") {
        this.$router.push({ name: "escalaAnualRhLicencaPremio" });
      }
    },
    excluirRegistro(dado) {
      //dado
      this.$http
        .delete(
          `${baseApiUrl}/escalaafastamentos/${dado.idenEscalaAfastamento}`
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Registro Excluido com Sucesso!",
            life: 3000,
          });
          this.carregarDados();
        });
    },
    fecharModalNovaEscala() {
      this.limparDados();
      this.modoEdicao = "adicionar";
      this.exibirTela = false;
    },
    buscarFiltro() {
      this.$http
        .get(
          `${baseApiUrl}/escalaafastamentos/${this.orgaoSelecionado.idenOrgao}/${this.filtroBusca}`
        )
        .then((res) => {
          this.escalas = res.data;
        });
    },
    selecionarTudo() {
      if (this.checkAllSelect[0]) {
        this.registro.listaOrgaos = this.orgaos;
      } else {
        this.registro.listaOrgaos = [];
      }
    },
  },
  mounted() {
    // Carrega os dados do serviço
    this.carregarDados();
  },
  computed: {
    validaPermissaoEditar() {
      if (this.modoEdicao == "alterar") {
        return true;
      } else if (this.bloquearPreencher) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.customer-badge-aguardando {
  border-radius: 2px;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  background-color: #c8e6c9;
  color: #256029;
}
.customer-badge-conflito {
  border-radius: 2px;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  background-color: #ffcdd2;
  color: #c63737;
}

.alinahmentoCabecalhoTabelaOrgaoEscala {
  justify-content: flex-end;
}
.alinahmentoBuscaFiltroOrgaoEscala {
  align-items: flex-end;
  margin: 0;
}
.alinhamentoCampoStatusFiltroOrgaoEscala {
  flex: 1;
}
.orgaosEscala {
  max-height: 25em;
  overflow: scroll;
}
</style>
